import { render, staticRenderFns } from "./NavLogo.vue?vue&type=template&id=0af6b2ea"
var script = {}
import style0 from "./NavLogo.vue?vue&type=style&index=0&id=0af6b2ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports